import { render } from "./homeTeacherTrain.vue?vue&type=template&id=fae6f6a2&scoped=true"
import script from "./homeTeacherTrain.vue?vue&type=script&lang=js"
export * from "./homeTeacherTrain.vue?vue&type=script&lang=js"

import "./homeTeacherTrain.vue?vue&type=style&index=0&id=fae6f6a2&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fae6f6a2"]])

export default __exports__